import React, { useEffect, useState } from 'react'
import {Form, FormGroup, Button} from 'react-bootstrap';
import { register } from '../../api/api';
// import { userData } from '../redux/slices/userSlice';
import { useSelector } from 'react-redux';
// import { getState } from '../components/getState';
import Cookie from 'react-cookies';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { DeleteForever } from '@mui/icons-material';


const Register = () => {
    const navigate = useNavigate();
    const {start_load, stop_load} = window;
    const [data, setData ] = useState({email: '', password: '', amount: 5050});
	// const [password, setPassword] = useState('');
	const [image, setImage] = useState();
    // const uData = useSelector(state => state.user.payload);
    // const uData = getState('user');
	const [paymentStatus, setPaymentStatus] = useState(false);
    const handleChange = (e) => {
        
        setData({ ...data, [e.target.name] : e.target.value});

    }
    const handleSubmit = async (e) => { 
      e.preventDefault()
      // start_load()
      // console.log('form submitted.');
      console.log(data);
      const response = await register(data);
      if(response.success){

        Swal.fire({
          icon: 'success',
          text: response.message,
          timer: 5000,
          toast: true,
          showConfirmButton: false,
          timerProgressBar: true,
          position: 'top-right'
          
        });
        navigate('/dashboard');
      }else{
        console.log(response);
        Swal.fire({
          icon: 'error',
          text: response.message,
          timer: 5000,
          toast: true,
          showConfirmButton: false,
          timerProgressBar: true,
          position: 'top-right'
          
        });
      }
      

    }

	function loadMonnifySDK(){
        // if(location.pathname == '/check-out' || location.pathname == '/fund'){
            const script = document.createElement("script");
            script.async = true;
            script.src = "https://sdk.monnify.com/plugin/monnify.js";
            
            document.head.appendChild(script);
        // }
    }
    function payWithMonnify() {
        // e.preventDefault();
		if(data.name == '' || data.email == '' || data.username == ''){
			Swal.fire({
				title: "Personal Details Required",
				text: 'Fill in your personal details.',
				// timer: 3000,
				icon: 'warning',
				confirmButtonColor: '#320808'
			})
		}else{
			console.log('working')
			window.MonnifySDK.initialize({
				amount: data.amount,
				currency: "NGN",
				reference: new String((new Date()).getTime()),
				customerFullName: data.name,
				customerEmail: data.email,
				apiKey: "MK_PROD_H9XYY3E27B",
				contractCode: "416343671879",
				paymentDescription: data.name +" BTA registration fee.",
				// metadata: {
				//     "name": "Damilare",
				//     "age": 45
				// },
				// incomeSplitConfig: [{
				//     "subAccountCode": "MFY_SUB_342113621921",
				//     "feePercentage": 50,
				//     "splitAmount": 1900,
				//     "feeBearer": true
				// }, {
				//     "subAccountCode": "MFY_SUB_342113621922",
				//     "feePercentage": 50,
				//     "splitAmount": 2100,
				//     "feeBearer": true
				// }],
				// onLoadStart: () => {
				//     console.log("loading has started");
				// },
				// onLoadComplete: () => {
				//     console.log("SDK is UP");
				// },
				onComplete: function(response) {
					//Implement what happens when the transaction is completed.
				   if( response.paymentStatus == 'PAID') {
					Swal.fire({
						title: "Cancelled",
						text: 'Payment Successful. You can continue with registration.',
						// timer: 3000,
						icon: 'success',
						confirmButtonColor: '#320808'
					})
					setPaymentStatus(true);
				   }else{
					Swal.fire({
						title: "Cancelled",
						text: response.responseMessage,
						// timer: 3000,
						icon: 'success',
						confirmButtonColor: '#320808',
						
					})
				   }
					// console.log(response);
				},
				onClose: function(data) {
					//Implement what should happen when the modal is closed here
					data.paymentStatus == 'USER_CANCELLED' &&
					 Swal.fire({
						title: "Cancelled",
						text: 'Payment Cancelled.',
						timer: 3000,
						icon: 'info',
						// confirmButtonColor: 'black',
						showCancelButton: false,
						showConfirmButton: false
					})
					// console.log(data);
				}
			});
		}
    }
    useEffect(() => {
        // console.log(height);
        loadMonnifySDK()
		document.title = 'Register | Bida Sport Club'
    }, [])
  return (
    <div className=' row login m-1 px-2 py-2 justify-content-center'
	style={{ 
		backgroundColor: 'whitesmoke',
		// height: '99vh'
	 }}
	>
      {/* <div className=" col-10 card"> */}
		<div className="col-10 card">
			<h2 className='mt-2 text-center'> <u>Register</u> </h2>
        <h3 className='mb-5 text-center'><b className="">Create New Member Account </b></h3> 

			<form action="" id="newUser"
			onSubmit={handleSubmit}
			>
				<input type="hidden" name="id" />
				<div className="row">
					<div className="col-md-6 border-right">
						<b className="text-muted">Personal Information</b>
						{
							 !image && 
							 <div className='d-flex justify-content-center align-items-center'>
                        <input type="file"  
                        onChange={(e) => {
                            console.log(e.target.files)
                            // let media = [...newsImages.media,...e.target.files]
                          setImage(e.target.files)
                            // dispatch(addProduct({media}))
                        }}
                        style={{display:"none"}} placeholder="Type here" name='file' className="form-control" id="uploadImages"
                        />
                        <label  htmlFor='uploadImages' className='upload-images-label d-flex justify-content-center align-items-center' style={{
                                display: "block",
                                width: "90%",
                                height:140,
                                borderStyle:'dashed',
                                borderColor:'GrayText',
                                borderWidth:0.5,
                                borderRadius:5,
                            }
                        }>
                            <span style={{fontSize:16}}> Click to Add  Member Image</span>
                        </label>
                        </div>
						}
						{
							image && 
							<div className='products-container d-flex justify-content-start align-items-center m-2'>
                            
                                        <div className='product-container d-flex-column mx-2 justify-content-center align-items-center' style={{
                                            cursor: "pointer",
                                            borderRadius:5,
                                            borderWidth:1,
                                            borderColor:"#e0e2e3",
                                }} >
                                        <img
                                            src={ typeof(image[0]) === 'object' ? URL.createObjectURL(image[0]) : image}
                                            width={80}
                                            height={80}
                                        />
                                        {/* <div className='delete-product d-flex justify-content-center align-items-center' style={{color:'#a50f0f'}} onClick={()=>{
                                            setNewsImages(newsImages.filter((_,ind)=> ind != index))
                                        }}>
                                            <i className="material-icons md-delete_forever"></i>
                                        </div> */}
                                        <DeleteForever
                                        className='d-flex justify-content-center align-self-center justify-contents-center'
                                        color='error'
                                        onClick={() => setImage()}
                                        />
                                </div>
                            
                        </div>
						}
						<div className="form-group">
							<label for="" className="control-label">Name</label>
							<input
							onChange={handleChange}
							type="text" name="name" className="form-control form-control-sm" required />
						</div>
						<div className="form-group">
							<label className="control-label">Email</label>
							<input 
							onChange={handleChange}
							type="email" className="form-control form-control-sm" name="email" required />
							<small id="#msg"></small>
						</div>
						<div className="form-group">
							<label for="" className="control-label">Phone</label>
							<input 
							onChange={handleChange}
							type="text" name="phone" className="form-control form-control-sm" required />
						</div>
						<div className="form-group">
							<label className="control-label">Username</label>
							<input 
							onChange={handleChange}
							type="text" className="form-control form-control-sm" name="username"  />
							
						</div>
						<div className="form-group">
							<label className="control-label">Address </label>
							<input 
							onChange={handleChange}
							type="text" className="form-control form-control-sm" name="address" />
							
						</div>
					</div>
					<div className="col-md-6">
					<b className="text-muted">Other Details </b>
						
						<div className="form-group">
							<label for="" className="control-label">Gender</label>
							<Form.Select 
							onChange={handleChange}
							size='sm' name="gender" id="gender" className="form-control">
								<option value="" >Select Gender ... </option>
								<option value="1" >Male </option>
								<option value="0" >Female</option>
							</Form.Select>
							<small><i></i></small>
						</div>
						<div className="form-group">
							<label for="" className="control-label">Select Unit</label>
							<Form.Select 
							onChange={handleChange}
							size='sm' name="unit" id="unit" className="form-control">
								<option value="" >Select Member Unit... </option>
								<option value="Badminton" >Badminton</option>
								<option value="Gym" >Gym</option>
								<option value="Table Tennis"> Table Tennis </option>
								<option value="Tennis"> Tennis </option>
							</Form.Select>
							<small><i></i></small>
						</div>
						<div className="form-group">
						{/* <b className="text-muted"> Select User Password Option </b>
							<select className='form-select'
							onChange={(e) => {
								// setPassword(e.target.value);
								if(e.target.value === 'default'){
									setData({...data, password : '0000'})
								}
							}}
							>
								<option className='text-muted'
								style={{ 
									opacity: '60%'
								 }}
								> Manage User Access Key... </option>
								<option value={'default'}> Use Default Password </option>
								<option value={'custom'}> Create a new password </option>
							</select> */}
                            <b className="text-muted">Create User Password </b>
								<div className="form-group">
									<label className="label control-label">Create Password</label>
									<input 
									onChange={handleChange}
									type="password" className="form-control form-control-sm" name="password" />
									<small id="pass_match" data-status=''></small>
								</div>
								<div className="form-group">
									<label className="label control-label">Confirm Password</label>
									<input 
									onChange={handleChange}
									type="password" className="form-control form-control-sm" name="cpassword" />
									<small id="pass_match" data-status=''></small>
								</div>
                            </div>
							{
								!paymentStatus && 
								<div>
								{/* <Form 
								// action="https://checkout.marasoftpay.live/"
								// target="_blank"
								method="post"
								onSubmit={payWithMonnify}
								> */}

									{/* <FormGroup>
										<Form.Label> Amount </Form.Label>
										<Form.Control type="number" 
										value={data.amount}
										onChange={handleChange}
										name="amount"
										placeholder="Enter amount you want to fund to your wallet"
										required
										>
										</Form.Control>
									</FormGroup> */}
									<h6> Pay 5000 naira registration Fee to continue. </h6>
									<Button 
									onClick={payWithMonnify}
									type="button" variant="dark" className=" btn-color w-100" style={{ marginTop: '20px' }}> Pay Now </Button>
									
									<small className=" text-muted" 
									style={{ color:'red', justifyItems: 'center', fontSize: 10}}> 
									50 flat rate charge!
									</small>
								{/* </Form> */}
							</div>
							}
					</div>
				</div>
				<hr />
				<div className="col-lg-12 pb-3 text-right justify-content-center d-flex">
					
					 <button className="btn btn-color btn-lg ms-2"
					  style={{ width: '200px' }}
					  disabled={!paymentStatus}
					 >Continue</button> 
				</div>
			</form>
		</div>
	{/* </div> */}
    </div>
  )
}

export default Register
